import axios from './index';

export const getTransactionRequest = (values) =>
  axios.get(
    `/v1/vendors/get/transactions/-/-/${values?.routeID || '-'}/${values?.from || '-'}/${
      values?.to || '-'
    }/-/-`
  );
